export enum ResponseStatuses {
  SUCCESS = 'img:check-circle',
  ERROR = 'img:close-circle'
}
